// extracted by mini-css-extract-plugin
export default {"model_response_container":"Testing2_model_response_container__9OOHp"};